import { Routes, Route } from 'react-router-dom';
import Layout from '../components/Layout/Layout';
import Tags from '../components/Masters/Tags/Tags';
import VideoLinks from '../components/Video/VideoLinks';
function VideoLink() {
    return (
        <div className='App'>
            <Routes>
                < Route path='/VideoLink' element={<Layout children={VideoLinks()} />} />
            </Routes>
        </div>
    )
}
export default VideoLink